// extracted by mini-css-extract-plugin
module.exports = {"container":"content-wrapper-module--container--3sER7","containerFullWidth":"content-wrapper-module--container-full-width--2DEHo"};